import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Pagination, Radio, Row, Select, Space, Table, Tabs } from 'antd';
import React, { useState } from 'react';
import { Link, useLoaderData, useNavigate, useParams } from 'react-router-dom';
import { MdArrowBackIosNew } from "react-icons/md";
import GoBack from '../../globalComponents/GoBack';

const columns = [
  {
    title: 'Reference',
    dataIndex: 'number',
    key: 'number',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'From',
    dataIndex: 'from',
    key: 'from',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'To',
    dataIndex: 'to',
    key: 'to',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Contact',
    dataIndex: 'contact',
    key: 'contact',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Scheduled Date',
    dataIndex: 'schedule_date',
    key: 'schedule_date',
    ellipsis: true,
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <span>{new Date(record.schedule_date).toUTCString()}</span>
  },
  {
    title: 'Source Document',
    dataIndex: 'source_document',
    key: 'source_document',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Action',
    key: 'operation',
    fixed: 'right',
    width: 100,
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
  }
]



const PurchaseOrderTransfers = () => {
  const transfers = useLoaderData();
  const navigate = useNavigate();
  const params = useParams();

  const goBack = () => navigate(-1);

  const onRow = (record, rowIndex) => {
    return {
      onClick: () => navigate(`/purchase/purchase-orders/${params.id}/transfers/${record.number.replaceAll('/', '-')}`)
    };
  }

  columns[columns.length - 1]['render'] = (_, record) => 
  <Link className='h-full w-full' to={`/purchase/purchase-orders/${params.id}/transfers/${record.number.replaceAll('/', '-')}`}>
    EDIT
  </Link>

  return (
    <div>
      <div className='flex justify-between mx-4'>
        <GoBack />
        <div className=' bg-white dark:bg-gray-900'>
          {/* <Input addonBefore={<MdFilterAlt />}  defaultValue="mysite" /> */}

          <Select
            mode='multiple'
            size={'middle'}
            placeholder='Filter'
            // defaultValue={['a10', 'c12']}
            // onChange={handleChange}
            className='w-96'
            options={[]}
          />
        </div>
      </div>
      <div className='flex justify-end mx-4 my-2'>
        <div className=''>
          {/* <Button className='' size={'sm'}>
            <Link to={'/inventory/transfers/new'} className='w-full'>New</Link>
          </Button> */}
        </div>
        <div className='dark:bg-gray-900'>
          <div className='flex justify-end'>
            <Pagination  total={50} />
          </div>
        </div>
      </div>
      <Table
        sticky
        key={'number'}
        onRow={onRow}
        rootClassName='hover:cursor-pointer'
        dataSource={transfers}
        columns={columns}
        scroll={{ x: 1500 }}
        pagination={false}
      />
    
    </div>
  )
}

export default PurchaseOrderTransfers;